<template>
  <div>


    <v-dialog persistent v-if="dialogyetki" v-model="dialogyetki" max-width="900px">
      <v-card color="grey lighten-5">
        <v-flex pl-3 pt-3 xs12 sm12>
          <span class="grey--text title"> {{ $t('Contract-v2') }} </span>
        </v-flex>
        <v-flex pa-1 xs12 sm12 md12>
          <v-layout row wrap>
            <v-flex pr-3 pt-3 xs12 sm12>
              <div class="scrollbar" id="style-1">
                <v-card color="white" flat>
                  <v-flex pl-3 pr-3 pt-3 xs12 sm12>
                    <div v-html="mesaj.SozlesmeText" class="force-overflow"></div>
                  </v-flex>
                </v-card>
              </div>
            </v-flex>
            <v-flex pl-3 xs12 sm12>
              <v-checkbox hide-details v-model="sozlesmeOnay" color="green" label="Sözleşmeyi kabul ediyorum.">
              </v-checkbox>
            </v-flex>
          </v-layout>

        </v-flex>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click="sozlesmeIptal()">{{$t("cancel_button")}}</v-btn>
          <v-btn color="info" flat :disabled="!sozlesmeOnay" @click="sozlesmeKabul()">{{ $t('Approve') }}</v-btn>
          <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>




    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"


  export default {
    props: ["value"],
    components: {

    },
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    beforeMount: beforeMount,
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    methods: {
      sozlesmeKabul() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var paramssozlesme = {
          ID: null,
          SozlesmeID: this.mesaj.SozlesmeID,
          UserID: credentials.UserID,
          ConfirmDate: helpers.getDateTimeNow(),
        }

        this.$http.post(auth.API_URL + 'api/Awed/AwedWebContractConfirm', paramssozlesme, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader(),
            'CariSirketNo': credentials.SirketKodu.toString(),
            'CoperSirketNo': credentials.CoperSirketNo.toString(),
            'MusteriKodu': credentials.AnaSirketKodu.toString()
          }
        }).then((response) => {

          if (response.body.Status == true) {
            this.resolve(true);
            this.dialogyetki = false

          } else {

          }

           this.text1 = this.$t(response.body.ResponseMessage);
          this.snackbar = true

        }, (response) => {
          this.text1 = 'Service Unavailable'
          this.snackbar = true


        })
      },
      sozlesmeIptal() {
        this.resolve(false);
        this.dialogyetki = false
      },


      open(mesaj) {
        this.mesaj = mesaj
        this.mesaj.SozlesmeText = this.mesaj.SozlesmeText

        this.dialogyetki = true;

        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });

      },
    },
    data() {
      return {
        bekle: false,
        islem: 0,
        sozlesmeOnay: false,
        mesaj: null,
        alertshow: false,
        alertmodel: true,
        tahsilatbakiyem: 0,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        dialogyetki: false,
        k: null,
        doviztipi: [],
        reject: null,
        tahsilatdialog: false,
        text1: null,
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },


    watch: {

    },
  }




  function beforeMount() {

  }
</script>
<style>
  header {
    font-family: 'Lobster', cursive;
    text-align: center;
    font-size: 25px;
  }

  #info {
    font-size: 18px;
    color: #555;
    text-align: center;
    margin-bottom: 25px;
  }

  a {
    color: #074E8C;
  }

  .scrollbar {
    margin-left: 10px;
    float: left;
    height: 300px;
    width: 100%px;
    background: rgb(255, 255, 255);
    overflow-y: scroll;
    margin-bottom: 25px;
  }

  .force-overflow {
    min-width: 800px;
  }

  #wrapper {
    text-align: center;
    width: 500px;
    margin: auto;
  }

  /*
 *  STYLE 1
 */

  #style-1::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  #style-1::-webkit-scrollbar {
    width: 12px;
    background-color: #F5F5F5;
  }

  #style-1::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: royalblue;
  }
</style>